import $api from "@/api/main"
import dayjs from 'dayjs'
import { reactive, ref, Ref, toRefs, onMounted, computed } from "vue";
import { ElMessageBox, ElMessage } from 'element-plus';
import { useRoute, useRouter } from "vue-router";
import utils from '@/utils/utils';


export function dayFunc() {
    return {
        dayjs
    }
}

export function listFunc(form: any, apiName: string, paging = true, cb?: any): any {
    // 分页默认配置
    const pageCof = {
        pageNum: 1,
        pageSize: 10,
        'orders[0].asc': false,
        // 'orders[0].column': 't.id',
    }

    let callbackFn:any = null;

    const data: any = reactive({
        list: [],
        total: 0
    })

    const mergeForm = reactive(Object.assign(pageCof, form))

    // 返回接口函数
    const interfaceFunc = $api[apiName]

    // 发送请求
    const send = async (...args: any) => {
        
        if (typeof args[0] === 'boolean' && args[0]) {
            mergeForm.pageNum = 1;
            data.total = 0
        }

        const result = await interfaceFunc(mergeForm);
        switch (args.length) {
            case 1:
                 if (typeof args[0] === 'function') {
                    result.list = args[0](result.list);
                    callbackFn = args[0];
                }
                break;
            case 2:
                if (typeof args[1] === 'function') {
                    result.list = args[1](result.list);
                    callbackFn = args[1];
                }
                break;
        }

        if (paging) {
            cb && cb(result);
            data.list = result.list
            data.total = result.total
        } else {
            data.list = result
        }
    }

    // 翻页
    const handlePageChange = ({ currentPage, pageSize }: any) => {
        mergeForm.pageNum = currentPage;
        mergeForm.pageSize = pageSize;
        send(false,callbackFn);
    }

    return {
        send,
        form: mergeForm,
        handlePageChange,
        data
    }
}

export function interfaceFunc(apis: any) {
    const factoryInterface: any = {}
    apis.forEach((apiNmae: string) => {
        factoryInterface[apiNmae] = $api[apiNmae]
    })
    return {
        ...factoryInterface
    }
}

export function applyUserFunc() {
    const data: any = reactive({
        tree: [],
    })

    const filter = (
        tree: any[],
        pathArray: any[],
        indexs: any[]
    ) => {
        for (let index = 0; index < tree.length; index++) {
            if (tree[index].selectable == false && !tree[index].children) {
                if(data.tree[index]) data.tree[index].disabled = true
            }
            else {
                if(data.tree[index]) data.tree[index].disabled = false
            }
            if (tree[index].children) {
                filter(tree[index].children, pathArray, indexs);
            }
            pathArray.pop();
            indexs.pop();
        }
    };

    onMounted(async () => {
        data.tree = await $api.getStaffTree();
        filter(data.tree, [], []);
    })

    return {
        ...toRefs(data),
    }
}

export function gridFunc(xTable: Ref, rowId = 'id') {
    const data: any = reactive({
        selectedPapers: new Set()
    })

    const appendRow = (row: any) => {
        xTable.value.insertAt(row, -1)
    }

    const clearData = () => {
        xTable.value.clearData()
    }

    const appendMultiRow = (multiRow: any) => {
        multiRow.map((row: any) => {
            xTable.value.insertAt(row, -1)
        })
    }

    const removeRow = (index?: number) => {
        xTable.value.remove(index)
    }
    // 获取表格变化的数据
    const getChangeRow = () => {
        return xTable.value.getRecordset();
    }
    // 获取表格全量的数据
    const getAllRow = () => {
        return xTable.value.getTableData();
    }

    // 实时更新footer数据统计
    const refreshFooterData = () => {
        xTable.value.updateFooter();
    }

    // 获取CheckBox选中的数据
    const getCheckboxRecords = ()=>{
        return xTable.value.getCheckboxRecords();
    }

    const togglePaperSelect = ({ rowid, checked, row }: any) => {
        if (checked) {
            data.selectedPapers.add(row);
        } else {
            data.selectedPapers.delete(row);
        }
    }

    const toggleAllPaperSelect = ({ records, checked }: any) => {
        if (checked) {
            records.forEach((item: any) => data.selectedPapers.add(item))
        } else {
            xTable.value.clearCheckboxRow();
        }
    }

    const setCheckbox = () => {
        getAllRow().tableData.forEach((paper: any) => {
            if (ids.value.includes(paper[rowId])) {
                xTable.value.setCheckboxRow(paper, true)
            }
        });
    }

    const clearCheckbox = () => {
        xTable.value.clearCheckboxRow()
        data.selectedPapers.clear()
    }

    const ids = computed(() => {
        return Array.from(data.selectedPapers).map((item: any) => item[rowId]);
    })

    const paperSelect = computed(() => {
        return Array.from(data.selectedPapers)
    })

    const loadData = (datas:any) => {
        xTable.value.loadData(datas);
    };

    const updateData = () => {
        xTable.value.updateData();
    }

    const reloadRow = (row:any, record:any, field?:any) => {
        xTable.value.reloadRow(row, record, field);
    }

    return {
        appendRow,
        appendMultiRow,
        removeRow,
        getChangeRow,
        setCheckbox,
        getAllRow,
        clearCheckbox,
        togglePaperSelect,
        toggleAllPaperSelect,
        refreshFooterData,
        ids,
        paperSelect,
        clearData,
        getCheckboxRecords,
        loadData,
        updateData,
        reloadRow,
    }
}

export function upLoadFunc() {
    const getUploadResultFn = (form: any, newValue: any, param: string | string[]) => {
        switch (true) {
            case param instanceof Array: {
                (param as []).forEach((el: any, i: number) => {
                    form[param[i]] = newValue[i] && newValue[i].fileId || ""
                })
                return true
            }
            case typeof param == 'string': {
                form[param as string] = newValue[0] && newValue[0].fileId || ""
                return true
            }
        }
    }

    return {
        getUploadResultFn
    }
}

export function createPageStateFunc(stateFunc: any) {
    const pageState: any = ref("")
    const route: any = useRoute();
    const pageStateFunc: any = computed(() => {
        switch (pageState.value) {
            case "add": {
                return stateFunc.add
            }
            case "edit": {
                return stateFunc.edit
            }
            default: {
                return {

                }
            }
        }
    })

    const setPageStateFunc = () => {
        pageState.value = route.meta.state
        return route;
    }

    return {
        setPageStateFunc,
        pageStateFunc
    }
}


export function execute() {
    const flowExe = (interfaceName: string, params: any, cofig: any) => {
        return new Promise((resolve, reject) => {
            const {
                confirmText = `是否确定${cofig.text}?`,
                type = 'warning',
                center = true,
                cancelButtonText = '取消',
                confirmButtonText = '确定',
            } = cofig

            ElMessageBox.confirm(confirmText, '提示', {
                type,
                center,
                cancelButtonText,
                confirmButtonText
            }).then(() => {

                $api[interfaceName](params)
                    .then(() => {
                        ElMessage.success({
                            message: `${cofig.text}，执行成功！`,
                            type: 'success'
                        });
                        resolve(true)
                    })
                    .catch(() => {
                        ElMessage.error(`${cofig.text}，执行失败！`);
                        reject(false)
                    })

            }).catch(() => {
                ElMessage('已取消执行！');
                reject(false)
            })
        })
    }

    const exportFn = (interfaceName: string, params: any, cofig: any) => {
        return new Promise((resolve, reject) => {
            $api[interfaceName](params)
                .then((res: Array<never>) => {
                    switch (cofig.type || "exc") {
                        case "exc": {
                            utils.downExcel(res, cofig.text + new Date().getTime().toString().substring(0, 6), false);
                            break;
                        }
                        case "pdf": {
                            utils.pdfDow(res, cofig.text + new Date().getTime().toString().substring(0, 6));
                            break;
                        }
                    }
                    ElMessage.success({
                        message: `导出成功！`,
                        type: 'success'
                    });
                    return resolve(true);
                })
                .catch(() => {
                    ElMessage.error('导出失败！');
                    reject(false)
                })
        })
    }

    return {
        flowExe,
        exportFn
    }
}